var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"12"}},[_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},_vm._l((_vm.$data._.each(_vm.items)),function(v,k){return _c('b-tab',{key:k,attrs:{"title":_vm.tabMapping[k]}},[_c('receipt-account-table-detail',{attrs:{"fields":_vm.fields[k],"items":v},on:{"updateData":_vm.getData}})],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bab8147","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/bank/ReceiptAccountTable.vue
// module id = 1473
// module chunks = 1